module.exports = __webpack_public_path__ + "components/country-flag/static/cf-f5c12629be4cc909489b16b0e3ca8c6f.svg";